export const GRD = {
  ENEDIS: "ENEDIS",
};
